export const TOGGLE_ON='TOGGLE_ON';
export const TOGGLE_OFF='TOGGLE_OFF';



// WEBPACK FOOTER //
// ./src/constants/Toggle.js